import type { RoutesWithBreadcrumbs } from '../../app.routes';

export const STUDENTS_ROUTES: RoutesWithBreadcrumbs = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'list',
  },
  {
    path: 'list',
    loadComponent: () => import('./students-list/students-list.component').then((c) => c.StudentsListComponent),
    data: {
      breadcrumbs: [{ label: 'Gestion des cours', routerLink: '/admin/classes' }, { label: 'Liste des étudiants' }],
    },
  },
  {
    path: 'add',
    loadComponent: () => import('./add-student/add-student.component').then((c) => c.AddStudentComponent),
    data: {
      breadcrumbs: [
        { label: 'Gestion des cours', routerLink: '/admin/classes' },
        { label: 'Étudiants', routerLink: '/admin/classes/students' },
        { label: 'Ajouter un étudiant' },
      ],
    },
  },
  {
    path: 'edit/:studentId',
    loadComponent: () => import('./edit-student/edit-student.component').then((c) => c.EditStudentComponent),
    data: {
      breadcrumbs: [
        { label: 'Gestion des cours', routerLink: '/admin/classes' },
        { label: 'Étudiants', routerLink: '/admin/classes/students' },
        { label: 'Modifier un étudiant' },
      ],
    },
  },
];
